/* eslint-disable no-unused-vars */
import moment from 'moment';
import {
    Steps,
    Space,
    Divider,
    Typography,
    PageHeader,
} from 'antd';
import { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { IBooking } from '../../interfaces/booking.interface';
import { TimelineType } from './TimelineType';

const { Step } = Steps;
const { Text, Title } = Typography;

const StatusUpdates: FC<Partial<IBooking> & {
    timelineType: boolean;
    handleChangeTimelineType: (type: boolean) => void;
}> = ({
    statusUpdates,
    timelineType,
    handleChangeTimelineType,
}: Partial<IBooking> & {
    timelineType: boolean;
    handleChangeTimelineType: (type: boolean) => void;
}) => {
    const { t } = useTranslation('bookings');

    const getDate = (date: Date) => moment(date).format('DD MMM HH:mm');

    return (
        <Space direction="vertical" size={12}>
            <PageHeader
                title={(
                    <Title level={5} style={{ marginBottom: 0 }}>
                        {t('DETAIL.STORY_LINE.TITLE')}
                    </Title>
                )}
                extra={[
                    <TimelineType
                        timelineType={timelineType}
                        handleChangeTimelineType={handleChangeTimelineType}
                    />,
                ]}
                footer={<Divider />}
            />

            <Text>
                {t('DETAIL.STORY_LINE.DESCRIPTION')}
            </Text>

            <div className="booking__timeline" style={{ paddingBottom: 24, overflowX: 'scroll' }}>
                <Steps
                    progressDot
                    current={statusUpdates?.length ? statusUpdates.length - 1 : 0}
                >
                    {statusUpdates?.map((status) => (
                        <Step
                            key={status.timeStamp.toString()}
                            title={(
                                <Text strong style={{ fontSize: 14, color: '#3F4D70' }}>
                                    {t(`STATUS.${status.newStatusText}`)}
                                </Text>
                            )}
                            subTitle={(
                                <Text className="booking__status--time">
                                    {getDate(status.timeStamp)}
                                </Text>
                            )}
                        />
                    ))}
                </Steps>
            </div>

        </Space>
    );
};

export default memo(StatusUpdates);
